import React, { useState, useEffect } from 'react';
import { IProjectItem } from '@src/entity/company/project';
import { ListView, PullToRefresh } from 'antd-mobile';
import { observer } from 'mobx-react';
import company from '@src/store/company';
import { Empty, SkeletonPage } from '@ywk/mobile-components';
import ListItem from '../ListItem';

const dataSource = new ListView.DataSource({ rowHasChanged: (row1, row2) => row1 !== row2 });
const TabContent = observer(
  (props: { sub: string; projects: IProjectItem[]; isloading: boolean; hasMore?: boolean }) => {
    const { projects, sub, isloading, hasMore } = props;
    const [refreshing, setRefreshing] = useState(false);
    const navEle = document.querySelector('.navbar');
    const navHeight = navEle ? navEle.clientHeight : 0;
    const [atEnd, setAtEnd] = useState(false);
    useEffect(() => {
      console.log('projects', projects);
    }, []);

    if (isloading && !refreshing) {
      return <SkeletonPage />;
    }
    if (!projects || !projects.length || projects.length === 0) {
      return <Empty txt="无数据" />;
    }

    function onRefresh() {
      setRefreshing(true);
      // company.project.selects.pagenum = 1;
      return company.project.getProjects().then(() => {
        setRefreshing(false);
      });
    }

    return (
      <ListView
        dataSource={dataSource.cloneWithRows(projects)}
        style={{
          height: document.documentElement.clientHeight - navHeight
        }}
        renderRow={(project, sectionID, rowID: React.ReactText) => {
          if (!project) return <div></div>;
          return <ListItem key={`${project.uuid}`} {...project} />;
        }}
        onEndReached={e => {
          console.log(e);
          setAtEnd(true);
        }}
        renderFooter={() => (
          <div style={{ textAlign: 'center' }}>
            {!hasMore ? '已经到底了' : atEnd === true ? '已经到底了' : '正在加载'}
          </div>
        )}
        // @ts-ignore
        pullToRefresh={<PullToRefresh refreshing={refreshing} onRefresh={onRefresh} />}
      />
    );
  }
);

export default TabContent;
